/**
 * @file utils/headers/constants.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */

export const VALID_CONTENT_TYPE = "application/json;charset=utf-8";
export const CONTENT_TYPE_KEY = "content-type";
